import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CategorySelect } from "@/components/brand-context/CategorySelect";
import { EntryTypeFilter } from "@/components/brand-context/entry";

interface EntryFilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  typeFilter: EntryTypeFilter;
  onTypeFilterChange: (value: EntryTypeFilter) => void;
  categoryFilter: string;
  onCategoryFilterChange: (value: string) => void;
}

export function EntryFilterBar({
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  categoryFilter,
  onCategoryFilterChange,
}: EntryFilterBarProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search context"
          className="pl-9 pr-9"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearchChange("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 rounded-sm text-muted-foreground hover:text-foreground"
            aria-label="Clear search"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <div className="relative w-full sm:w-[160px]">
        <Select value={typeFilter} onValueChange={(v) => onTypeFilterChange(v as EntryTypeFilter)}>
          <SelectTrigger className={typeFilter !== "all" ? "pr-9" : undefined}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-popover border border-border">
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="document">Documents</SelectItem>
            <SelectItem value="learning">Learnings</SelectItem>
          </SelectContent>
        </Select>
        {typeFilter !== "all" && (
          <button
            type="button"
            onClick={() => onTypeFilterChange("all")}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 rounded-sm text-muted-foreground hover:text-foreground z-10"
            aria-label="Clear type filter"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <div className="relative w-full sm:w-[200px]">
        <CategorySelect
          value={categoryFilter}
          onValueChange={onCategoryFilterChange}
          includeAllOption
          className={categoryFilter !== "all" ? "pr-9" : undefined}
        />
        {categoryFilter !== "all" && (
          <button
            type="button"
            onClick={() => onCategoryFilterChange("all")}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 rounded-sm text-muted-foreground hover:text-foreground z-10"
            aria-label="Clear category filter"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
